import React from "react";
import { ICreatorCommentSymbolProps } from "./CreatorCommentSymbol.types";
import { CREATOR_COMMENT_SYMBOL_RELATIVE_PATH } from "../../../../../../components/BrandedCommunity/Post/components/Comment/constants/Comment.constants";

const CreatorCommentSymbol = ({
  fetchCdnAsset,
  isCommentFromCreator,
}: ICreatorCommentSymbolProps) => {
  if (!(fetchCdnAsset && isCommentFromCreator)) return null;
  return (
    <img
      src={fetchCdnAsset(CREATOR_COMMENT_SYMBOL_RELATIVE_PATH)}
      height={16}
      width={16}
    />
  );
};

export default CreatorCommentSymbol;
